<template>
  <div class="paymentOfferContainer">
    <div class="paymentSubGrid imgGrid">
      <p class="ralewayBold accountText mt-8">
        {{ $t('k_payment_offer_title') }}
      </p>
    </div>
    <div class="grid mt-8">
      <p
        class="ralewayBold formLeftText mt-1"
        v-html="$t('k_payment_offer_membership')"
      ></p>
    </div>
    <div class="grid mt-3">
      <div class="planContainer">
        <p class="ralewayBold planText1">
          {{ this.smartTalesTitle }}
        </p>
        <div class="planToday">
          <span class="ralewayBold todayPriceNumber">0</span>
          <span
            class="ralewayBold todayPriceText"
            v-html="$t('k_payment_offer_zero_today', [this.currency])"
          ></span>
        </div>

        <p class="nunitoRegular planText3">
          {{ originalPriceText }}
        </p>
        <p class="nunitoRegular planText3">
          {{ trialEndText }}
        </p>
        <p class="nunitoRegular planText3">
          {{ thereafterPriceText }}
        </p>
        <p
          class="ralewayBold planTextMinimum"
          v-html="$t('k_payment_offer_no_minimum_committment')"
        ></p>
      </div>
    </div>
    <div class="grid mt-4">
      <p class="ralewayBold formLeftText mt-5">{{ $t('k_info_payment') }}</p>
    </div>
    <div class="formContainer mt-5">
      <div class="formElement">
        <label class="ralewayBold formInputLabel" for="cardNumber">{{
          $t('k_card_number')
        }}</label>
        <div id="cardStripe" name="cardNumber" class="formInput"></div>
      </div>
      <div class="formElementNameHalf1">
        <label class="ralewayBold formInputLabel" for="name">{{
          $t('k_name_title')
        }}</label>
        <input
          class="formInput ralewayRegular"
          type="text"
          name="name"
          v-model="name"
          v-bind:placeholder="$t('k_name_title')"
        />
      </div>
      <div class="formElementNameHalf2">
        <label class="ralewayBold formInputLabel" for="surname">{{
          $t('k_surname_title')
        }}</label>
        <input
          class="formInput ralewayRegular"
          type="text"
          name="surname"
          v-model="surname"
          v-bind:placeholder="$t('k_surname_title')"
        />
      </div>

      <div class="paymentOfferButton payButton" v-on:click="onClickPayPremium">
        <div class="stButtonCaption nunitoBold">
          {{ $t('k_payment_offer_activate_membership') }}
        </div>
      </div>
      <div
        class="paymentOfferPaySocialButton payProviderButton"
        v-if="paymentRequestSupport"
      >
        <div class="stButtonCaption nunitoBold" v-on:click="onClickPaySocial">
          <div>
            <p>
              {{
                this.platform == 'ios' ? $t('k_pay_apple') : $t('k_pay_google')
              }}
              <font-awesome-icon
                v-if="socialIcon"
                v-bind:icon="socialIcon"
                transform="grow-8 down-1 right-4"
                size="lg"
              />
            </p>
          </div>
        </div>
      </div>
      <p class="payText ralewayRegular">
        {{ $t('k_payment_offer_smart_footer') }}
      </p>
      <div class="payInfo1 ralewayBold">
        <img class="payTextImg mt-2" src="@/assets/images/lock_icon.png" />
        <p class="mt-4">{{ $t('k_payment_offer_safe_checkout') }}</p>
        <img
          class="payTextImg2 mt-4"
          src="@/assets/images/powered_by_stripe_icon.png"
        />
      </div>
      <div class="cardsContainer mt-5">
        <img class="cardsImage" src="@/assets/images/credit_amex_icon.png" />
        <img
          class="cardsImage"
          src="@/assets/images/credit_mastercard_icon.png"
        />
        <img
          class="cardsImage"
          src="@/assets/images/credit_visa_electron_icon.png"
        />
        <img class="cardsImage" src="@/assets/images/credit_visa_icon.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '../plugins/api'
import { trackEvent } from '../plugins/analyticsTracker'
import { getStripeObject } from '../plugins/stripe'
import moment from 'moment'
import decodeUriComponent from 'decode-uri-component'

export default {
  data() {
    return {
      smartTalesTitle: '',
      originalPriceText: '',
      thereafterPriceText: '',
      paymentRequestEnabled: false,
      trialEndText: '',
      userInfo: '',
      password: '',
      submitted: false,
      premium: true,
      itemSelected: 1,
      name: null,
      surname: null,
      promo: null,
      currency: '€',
      platform: null,
      socialIcon: null,
      paymentRequestData: null,
      stripe: null,
      subYearly: null,
      subMonthly: null,
      paymentRequestSupport: false,
      stripeCustomer: null,
      cardValid: false,
      cardElement: null,
      stripeCoupons: [],
      couponAppliedMessage: '',
      trialInfo: null,
      subPrice: null,
      subPriceWithUnit: null
    }
  },
  components: {},
  computed: {
    ...mapState({
      email: state => state.userInfo?.email
    })
  },
  async mounted() {
    trackEvent(this.$constants.WEB_PAYWALL_OPEN, {
      offerType: this.$route.query.offerType,
      lang: this.$i18n.locale
    })
    const revenuecatRespone = await api.get(`/user/revenueCat`)
    const subs =
      revenuecatRespone &&
      revenuecatRespone.data &&
      revenuecatRespone.data.subscriptions
        ? revenuecatRespone.data.subscriptions
        : []
    if (subs.length > 0)
      this.$router.push({
        path: '/profile',
        query: this.query
      })
    this.stripe = await getStripeObject()
    const fontSize = window.innerWidth >= 1200 ? '18.75px' : '15px'
    this.elements = this.stripe.elements({
      fonts: [
        {
          src:
            'url(https://fonts.gstatic.com/s/raleway/v17/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaooCM.woff)',
          family: 'Raleway'
        }
      ],
      locale: this.$i18n.locale
    })
    // Create a Card Element and pass some custom styles to it.
    this.cardElement = this.elements.create('card', {
      classes: {
        base: 'stripeCard'
      },
      hidePostalCode: true,
      style: {
        base: {
          color: '#6a6a6a',
          fontFamily: 'Raleway',
          fontWeight: 400,
          fontStyle: 'normal',
          fontSmoothing: 'antialiased',
          fontSize: fontSize
        }
      }
    })
    this.cardElement.mount('#cardStripe')
    this.cardElement.on('change', event => {
      if (event.complete) {
        this.cardValid = true
      } else if (event.error) {
        this.cardValid = false
      }
    })

    if (/Android/i.test(navigator.userAgent)) {
      this.platform = 'android'
      this.socialIcon = ['fab', 'google-pay']
      console.log(this.platform)
    } else if (/iPhone|iPad|Macintosh|iPod/i.test(navigator.userAgent)) {
      this.platform = 'ios'
      this.socialIcon = ['fab', 'apple-pay']
      console.log(this.platform)
    }
    const pricesInfoResp = await api.get('/user/stripe/subscription/info')
    this.trialInfo = pricesInfoResp.data.trialInfo
    this.stripeCustomer = pricesInfoResp.data.customer
    this.stripeCoupons = pricesInfoResp.data.coupons
    this.subYearly = pricesInfoResp.data.subscriptions.find(
      x => x && x.recurring && x.recurring.interval == 'year'
    )
    this.subMonthly = pricesInfoResp.data.subscriptions.find(
      x => x && x.recurring && x.recurring.interval == 'month'
    )
    this.currency =
      this.subYearly.currency == 'eur'
        ? '€'
        : this.subYearly.currency == 'gbp'
        ? '£'
        : '$'
    this.calculateSubscriptionPrice()
    const offerType = this.$route.query.offerType
    this.itemSelected = offerType == 'year' ? 1 : 2
    this.smartTalesTitle =
      offerType == 'year'
        ? this.$i18n.t('k_payment_offer_smart_yearly')
        : this.$i18n.t('k_payment_offer_smart_monthly')
    this.calculateSubscriptionPrice()
    this.setCalculatedPricesText()
    this.paymentRequestData = this.stripe.paymentRequest({
      currency:
        this.itemSelected == 1
          ? this.subYearly.currency
          : this.subMonthly.currency,
      country: 'IT',
      total: {
        label: 'Smart Tales Premium',
        amount: Number(this.subPrice)
      },
      requestPayerName: true,
      requestPayerEmail: true
    })

    // Check if the Payment Request is available (or Apple Pay on the Web).
    this.paymentRequestSupport = await this.paymentRequestData.canMakePayment()
    this.paymentRequestData.on('paymentmethod', this.onPaymentRequestHandler)
  },
  methods: {
    setCalculatedPricesText: function() {
      const elem = this.itemSelected == 1 ? this.subYearly : this.subMonthly
      this.smartTalesTitle =
        this.itemSelected == 1
          ? this.$i18n.t('k_payment_offer_smart_yearly')
          : this.$i18n.t('k_payment_offer_smart_monthly')
      const pricePerMonth =
        this.itemSelected == 1
          ? (this.subPriceWithUnit / 12).toFixed(2)
          : this.subPriceWithUnit
      this.originalPriceText =
        this.itemSelected == 1
          ? this.$i18n.t('k_payment_offer_original_price_yearly', [
              pricePerMonth + this.currency
            ])
          : this.$i18n.t('k_payment_offer_original_price_monthly', [
              pricePerMonth + this.currency
            ])

      this.thereafterPriceText =
        this.itemSelected == 1
          ? this.$i18n.t('k_payment_offer_thereafter', [
              this.subPriceWithUnit + this.currency
            ])
          : this.$i18n.t('k_payment_offer_thereafter', [
              this.subPriceWithUnit + this.currency
            ])
      if (elem) {
        const endTrialDate = moment()
          .add(elem.trial, 'days')
          .endOf('day')
          .format('DD/MM/YYYY')
        this.trialEndText = elem
          ? this.$i18n.t('k_payment_offer_free_until', [endTrialDate])
          : ''
      } else this.trialEndText = ''
    },
    onClickPayPremium: async function() {
      trackEvent(this.$constants.WEB_PAY_SUBS_PRESSED, {
        offerType: this.$route.query.offerType
      })
      try {
        const premiumPaymentMethodData = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.cardElement,
          billing_details: {
            name: `${this.name} ${this.surname}`
          }
        })
        this.onPaymentRequestHandler(
          {
            paymentMethod: premiumPaymentMethodData.paymentMethod
          },
          true
        )
      } catch (error) {
        await this.$store.dispatch('setError', {
          errorKey: 'k_stripe_error_title',
          errorSubKey: 'k_stripe_error_subtitle',
          errorImage: '@/assets/images/mosquita_error.png',
          redirect: '/profile'
        })
        this.$router.push({
          path: '/error'
        })
      }
    },
    onClickPaySocial: async function() {
      trackEvent(
        this.platform == 'ios'
          ? this.$constants.WEB_PAY_SUBS_APPLEPAY
          : this.$constants.WEB_PAY_SUBS_GOOGLEPAY,
        { offerType: this.$route.query.offerType }
      )
      this.paymentRequestSupport = await this.paymentRequestData.canMakePayment()
      if (this.paymentRequestSupport) this.paymentRequestData.show()
    },
    calculateSubscriptionPrice() {
      if (!this.subYearly || !this.subMonthly) return 0
      let finalPrice = null
      const price =
        this.itemSelected == 1
          ? this.subYearly.unit_amount
          : this.subMonthly.unit_amount
      finalPrice = price

      this.subPriceWithUnit = finalPrice / 100
      this.subPrice = Math.round(finalPrice)
    },
    onPaymentRequestHandler: async function(event, creditCard) {
      const paymentMethod = event.paymentMethod
      const priceId =
        this.itemSelected == 1 ? this.subYearly.id : this.subMonthly.id
      if (paymentMethod) {
        await api.post('/user/stripe/subscription', {
          paymentId: event.paymentMethod.id,
          coupon: this.appliedCoupon ? this.appliedCoupon.id : null,
          priceId: priceId,
          lang: this.$i18n.locale,
          stripeCustomerId: this.stripeCustomer.id,
          paywallId: 'webPaywallOffer'
        })
        if (!creditCard) event.complete()
        const platformType = this.platform ? this.platform : 'card'
        trackEvent(this.$constants.WEB_SUBS_CONFIRMED, {
          offerType: this.$route.query.offerType,
          paymentType: platformType,
          lang: this.$i18n.locale
        })
        if (this.$route.query.returnUrl) {
          const decodedUrl = decodeUriComponent(this.$route.query.returnUrl)
          window.location = `${decodedUrl}?offerType=${this.$route.query.offerType}`
        } else this.$router.push({ path: '/payment-success' })
      } else {
        trackEvent(this.$constants.WEB_SUBS_CANCELED)
        if (!creditCard) event.fail()
        await this.$store.dispatch('setError', {
          errorKey: 'k_stripe_error_title',
          errorSubKey: 'k_stripe_error_subtitle',
          errorImage: '@/assets/images/mosquita_error.png',
          redirect: '/profile'
        })
        this.$router.push({
          path: '/error'
        })
      }
    }
  }
}
</script>
<style lang="scss">
.paymentOfferContainer {
  .appliedCouponText {
    font-size: 0.688em;
    color: #54d0c6;
    text-align: left;
  }
  .trialText {
    font-size: 0.688em;
    color: var(--formColor);
    text-align: center;
  }
  .couponOldPrice {
    text-decoration: line-through;
    color: var(--subtextColor);
    font-size: 0.75em;
  }

  .imgBestValue {
    position: relative;
    bottom: -25px;
    left: -25px;
    z-index: 1000;
    width: 35%;
  }

  .payTextImg {
    width: 10%;
    align-self: left;
  }

  .payTextImg2 {
    width: 20%;
    align-self: right;
  }

  .payInfo1 {
    display: flex;
    flex-direction: row;
    font-size: 0.5em;
    color: var(--formColor);
    text-align: center;
    grid-row: 8;
    grid-column: 3/11;
    align-items: center;
    justify-content: space-evenly;
  }

  .payText {
    font-size: 0.75em;
    color: var(--formColor);
    text-align: left;
    grid-row: 7;
    grid-column: 3/11;
  }
  .payButton {
    grid-row: 5;
    grid-column: 3/11;
    padding: 15px 0px;
  }

  .payProviderButton {
    grid-row: 6;
    grid-column: 3/11;
    padding: 15px 0px;
  }

  .paymentSubGrid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  @keyframes scaleup {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.1);
    }
  }

  @keyframes scaledown {
    0% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  .cardsImage {
    width: 23%;
    margin-right: 4px;
  }

  .formLeftText {
    grid-column: 2/6;
    grid-row: 1;
    font-size: 0.875em;
    color: var(--formColor);
    text-align: left;
  }

  .weAcceptText {
    grid-column: 2/4;
    grid-row: 2;
    font-size: 0.875em;
    color: var(--formColor);
    text-align: left;
  }

  .cardsContainer {
    grid-column: 5/9;
    grid-row: 9;
    display: flex;
    align-items: center;
  }

  .amountLabel {
    font-size: 0.75em;
    color: var(--formColor);
    text-align: left;
    grid-row: 5;
    grid-column: 2/5;
    text-align: left;
  }

  .amountValueContainer {
    grid-row: 5;
    grid-column: 10/12;
    text-align: right;
  }

  .amountValue {
    font-size: 0.85em;
    color: var(--formColor);
    text-align: right;
  }

  .planContainer .planText1 {
    font-size: 1.063em;
    color: var(--formColor);
    grid-column: 2/19;
    text-align: left;
    grid-row: span 2;
  }

  .planContainer .planToday {
    font-size: 1.063em;
    color: var(--formColor);
    grid-column: 13/19;
    text-align: right;
    grid-row: span 99;
    align-self: center;
  }
  .planContainer .planTextMinimum {
    font-size: 0.9em;
    color: var(--formColor);
    grid-column: 2/19;
    text-align: left;
    grid-row: span 2;
  }

  .planContainer .planText3 {
    font-size: 0.8em;
    color: var(--formColor);
    grid-column: 2/12;
    text-align: left;
  }

  .helpText {
    margin: 20px 0;
    color: var(--formColor);
    grid-row: 4;
    grid-column: 2/12;
  }
  .emailContainer {
    display: flex;
    flex-direction: column;
    grid-row: 3;
    grid-column: 5/8;
    align-items: flex-start;
  }
  .imgGrid {
    align-self: center;
    grid-row: 1;
    grid-column: 1/9;
    width: 100%;
    max-width: 400px;
  }
  .accountText {
    grid-row: 1;
    grid-column: 2/12;
    font-size: 1.3em;
    color: var(--formColor);
    line-height: 0.9em;
    text-align: center;
  }

  .accountText2 {
    grid-row: 3;
    grid-column: 2/12;
    font-size: 0.9em;
    color: var(--formColor);
    text-align: left;
  }
  .accountText4 {
    grid-row: 6;
    grid-column: 2/6;
    font-size: 0.75em;
    color: var(--formColor);
    align-self: center;
    text-align: left;
  }

  .accountText3 {
    grid-row: 5;
    grid-column: 2/12;
    font-size: 0.88em;
    color: var(--formColor);
    align-self: center;
    text-align: left;
  }
  .stripeImg {
    grid-row: 6;
    grid-column: 10/12;
    width: 130%;
    align-self: flex-end;
  }

  .emailText {
    grid-row: 3;
    grid-column: 2/4;
    font-size: 0.875em;
    color: var(--tertiary);
  }

  .planContainer {
    grid-column: 2/12;
    display: grid;
    grid-template-columns: repeat(20, 1fr);
    box-shadow: 0px 0px 6px rgba(85, 30, 210, 0.19);
    border-radius: 13px;
    border: 1px solid var(--outlineInput);
    padding-bottom: 0.7em;
  }

  .planText {
    display: flex;
    grid-row: 5;
    grid-column: 5/7;
    font-size: 0.875em;
    color: var(--tertiary);
  }

  .forgotText {
    grid-row: 3;
    grid-column: 2/4;
    font-size: 0.75em;
    color: var(--primary);
  }

  .imgGrid .subheaderText {
    grid-row: 2;
    grid-column: 1/9;
    font-size: 1.56em;
    color: var(--secondary);
  }
  .imgBestValueSelected {
    border: none !important;
    transform: scale(1.1);
    animation: scaleup 0.2s;
    opacity: 1 !important;
  }

  .planButton2 {
    grid-column: 12/18;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .buttonCaption {
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .hrLine {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid var(--line1);
    line-height: 0.1em;
    margin: 10px 0 10px;
    grid-row: 2;
    grid-column: 2/12;
  }

  .hrLineAmount {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid var(--line1);
    line-height: 0.1em;
    margin: 10px 0 10px;
    grid-row: 6;
    grid-column: 2/12;
  }

  .hrLine2 {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid var(--line1);
    line-height: 0.1em;
    margin: 10px 0 20px;
    grid-row: 4;
    grid-column: 2/12;
  }

  .hrLine3 {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid var(--line2);
    line-height: 0.1em;
    margin: 20px 0 20px;
    grid-row: 6;
    grid-column: 2/12;
  }

  .hrLine span {
    padding: 0 10px;
    background: #fff;
    color: var(--line1);
    font-size: 0.5em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 10px;
  }

  .promoInput {
    display: flex;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .buttonPromo {
    margin: 1px 1px;
    padding: 0px 2px;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 0.725em;
    background-color: #dedddd;
    color: var(--formColor);
    outline: none;
    white-space: nowrap;
  }

  .formInputPromo {
    flex-grow: 2;
    border: 0px !important;
  }

  .formElement {
    grid-column: 2/12;
    grid-row: 1;
  }

  .formElementPromo {
    grid-column: 2/12;
    grid-row: 4;
  }

  .formElementPromoBtn {
    margin-left: 0px;
  }

  .formElementNameHalf1 {
    grid-column: 2/7;
    grid-row: 2;
  }
  .formElementNameHalf2 {
    grid-column: 7/12;
    grid-row: 2;
  }

  .formInputLabel {
    display: flex;
    font-size: 0.75em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 0.938em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }

  .todayPriceNumber {
    font-size: 1.25em;
  }
  .todayPriceText {
    font-size: 0.9em;
  }
  @media screen and (min-width: 620px) {
    .imgGrid {
      max-width: 900px;
    }

    .stripeImg {
      max-width: 100px;
      grid-column: 7/8;
    }

    .planText1 {
      margin-top: 1rem !important;
    }

    input::placeholder {
      color: var(--formColor);
    }
  }
  .stripeCard {
    padding-top: 12.5px;
    padding-bottom: 12.5px;
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
